import { render, staticRenderFns } from "./strategyTime.vue?vue&type=template&id=81dd821c&"
import script from "./strategyTime.vue?vue&type=script&lang=js&"
export * from "./strategyTime.vue?vue&type=script&lang=js&"
import style0 from "./strategyTime.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports